export const tabs = [
  {
    key: 'Win',
    title: 'Windows',
  },
  {
    key: 'Linux',
    title: 'Linux',
  },
  {
    key: 'Mac',
    title: 'MacOS',
  },
  {
    key: 'mobile',
    title: 'Mobile',
  },
];

export const getPublicBucketUrl = (production) =>
  `${
    process.env.NODE_ENV === 'production' ? 'https' : 'http'
  }://downloads.erply.com/${production ? 'production' : 'test'}`;
